import { useState } from "react";
import NavBar from "@/components/NavBar";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import BasicInfoStep from "@/components/create/BasicInfoStep";
import KnowledgeStep from "@/components/create/KnowledgeStep";
import SettingsStep from "@/components/create/SettingsStep";
import EmbedCode from "@/components/EmbedCode";
import { toast } from "sonner";

export default function CreateBot() {
  const [step, setStep] = useState(0);
  const [data, setData] = useState({ name: "", persona: "", greeting: "", sources: "", nsfw: true, temperature: 0.7 });

  const next = () => setStep((s) => Math.min(2, s + 1));
  const back = () => setStep((s) => Math.max(0, s - 1));
  const saveLocal = () => {
    localStorage.setItem("bot-draft", JSON.stringify(data));
    toast.success("Draft saved locally. Connect backend to persist.");
  };

  return (
    <div className="min-h-screen bg-hero">
      <NavBar />
      <main className="mx-auto max-w-5xl px-4 py-10">
        <Card>
          <CardHeader>
            <CardTitle>Create your chatbot</CardTitle>
          </CardHeader>
          <CardContent className="space-y-8">
            {step === 0 && <BasicInfoStep value={data} onChange={setData} />}
            {step === 1 && <KnowledgeStep value={data} onChange={setData} />}
            {step === 2 && <SettingsStep value={data} onChange={setData} />}

            <div className="flex items-center justify-between">
              <Button variant="outline" onClick={back} disabled={step===0}>Back</Button>
              {step < 2 ? (
                <div className="flex gap-2">
                  <Button variant="ghost" onClick={saveLocal}>Save draft</Button>
                  <Button onClick={next}>Next</Button>
                </div>
              ) : (
                <div className="flex gap-2">
                  <Button variant="ghost" onClick={saveLocal}>Save draft</Button>
                  <Button asChild><a href="#embed">Get embed</a></Button>
                </div>
              )}
            </div>

            <div id="embed">
              <EmbedCode name={data.name || "My Creator Bot"} />
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
}
